module.exports = __webpack_public_path__ + "static/logoFE-b0ea3cfcc315dd11f74f00176ef10218.svg";